import { IBookingState } from "../interfaces/app.interface";

const validateAdditionalStop = (booking: IBookingState, google: any): Promise<number> => {
  return new Promise(resolve => {
    if ((+booking.current_location_map.lat === +booking.additional_stop.value.lat &&
      +booking.current_location_map.lng === +booking.additional_stop.value.lng) ||
      (+booking.destination_location_map.lat === +booking.additional_stop.value.lat &&
        +booking.destination_location_map.lng === +booking.additional_stop.value.lng)
    ) {
      resolve(0)
    }

    const service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [{ lat: Number(booking.destination_location_map.lat), lng: Number(booking.destination_location_map.lng) }],
        destinations: [{ lat: Number(booking.additional_stop.value.lat), lng: Number(booking.additional_stop.value.lng) }],
        travelMode: 'DRIVING',
        unitSystem: window.google.maps.UnitSystem.METRIC,
        avoidHighways: true,
        avoidTolls: true,
      }, callback);

    function callback(response: any, status: any) {
      if (status === 'OK') {
        resolve(response.rows[0].elements[0].distance.value);
      }
    }
  })

}

export const validateAdditionalStopService = {
  validateAdditionalStop
}
